import React, { useState, useEffect} from 'react';
import { Tooltip } from 'antd';
import { Fa } from '../layout/Fa';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';

export function TooltipHint({ hintText, ...props }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        setVisible(false);
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);
  return (
    <span {...props}
      tabIndex="0"
      aria-label={hintText}
      onFocus={()=>{setVisible(true)}}
      onBlur={()=>setVisible(false)}
      onMouseEnter={()=>{setVisible(true)}}
      onMouseLeave={()=>setVisible(false)}
        >
      <Tooltip visible={visible} title={hintText} >
        <Fa icon={faQuestionCircle} color="#00739d" aria-hidden={false} />
      </Tooltip>
    </span>
  );
}